<template>
  <div class="usage-section usage-section--templates">
    <rest-list ref="list" :payload="fetchEndpoint" class="usage-table">
      <rest-list-column
        prop="template_title"
        :title="$t('EmailRows_Table_LinkedCampaignName')"
        :min-width="200"
        :sortable="false"
      >
        <template v-slot="scope">
          <a
            :href="editRoute(scope.row)"
            :data-qa="`linked-message-template-${scope.row.template_id}`"
          >
            {{ scope.row.template_title }}
          </a>
        </template>
      </rest-list-column>

      <rest-list-column
        prop="is_active"
        :title="$t('EmailRows_Table_Active')"
        :min-width="80"
        :sortable="false"
        :filter-input="false"
        :filter-options="activeOptions"
        filter-field="is_active"
      >
        <template v-slot="scope">
          <el-tag :type="scope.row.is_active ? 'success' : 'info'" size="small">
            {{
              scope.row.is_active
                ? $t('EmailRows_Table_Active_Yes')
                : $t('EmailRows_Table_Active_No')
            }}
          </el-tag>
        </template>
      </rest-list-column>

      <rest-list-column-date
        prop="synced_at"
        :title="$t('EmailRows_Table_LastSynced')"
        :min-width="200"
        :unix="false"
        :sortable="false"
        date-format="DD/MM/YYYY HH:mm"
      />

      <rest-list-column
        prop="is_stale"
        :title="$t('EmailRows_Table_SyncStatus')"
        :min-width="100"
        :sortable="false"
        :filter-input="false"
        :filter-options="syncStatusOptions"
        filter-field="is_stale"
      >
        <template v-slot="scope">
          <el-tag
            :type="scope.row.is_stale ? 'warning' : 'success'"
            size="small"
          >
            {{
              scope.row.is_stale
                ? $t('EmailRows_Table_SyncStatus_Stale')
                : $t('EmailRows_SyncStatus_InSync')
            }}
          </el-tag>
        </template>
      </rest-list-column>

      <rest-list-column
        prop="synced_content_version"
        :title="$t('EmailRows_Table_SyncedVersion')"
        :min-width="55"
        :sortable="false"
        :filterable="false"
      />
    </rest-list>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint } from '@/core/helpers'
import { campaignContentRoute } from '@/modules/email-saved-rows/helpers/campaignContentRoute'

export default {
  name: 'SyncedRowMessageTemplateUsageTable',
  components: {
    RestList,
    RestListColumn,
    RestListColumnDate
  },

  props: {
    contentId: {
      type: Number,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `content/${this.contentId}/usage-messages`,
        params: {
          type: 'message-template'
        }
      })
    },

    activeOptions() {
      return {
        active: this.$t('EmailRows_Table_Active_Yes'),
        inactive: this.$t('EmailRows_Table_Active_No')
      }
    },

    syncStatusOptions() {
      return {
        stale: this.$t('EmailRows_Table_SyncStatus_Stale'),
        synced: this.$t('EmailRows_SyncStatus_InSync')
      }
    },

    canEdit() {
      return this.$can('CampaignTemplate:FullAccess')
    }
  },

  methods: {
    refresh() {
      this.$refs.list.refresh(true)
    },

    editRoute(row) {
      return campaignContentRoute(
        '/push/campaign-template',
        {
          id: row.template_id,
          project_id: this.$route.query.project_id,
          channel: 'email',
          variant: row.variant_key,
          lang: row.language
        },
        this.canEdit
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.rest-list-column-link {
  font-size: 16px;
  color: #1d87c9;
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/modules/email-saved-rows/components/SyncedRowMessageTemplateUsageTable.vue